<ng-container
  *ngIf="{
    product: product$ | async,
    isLogged: isLogged$ | async,
  } as content"
>
  @if (content.product?.discontinued) {
    <span class="ff-bold m-t-20 text-danger">
      {{ 'productRow.noLonger' | cxTranslate }}
    </span>

    <product-replacement [product]="content.product!"></product-replacement>
  } @else {
    <ng-container *ngIf="content.product?.potentialPromotions?.length">
      <cx-promotions *cxFeature="'showPromotionsInPDP'" [promotions]="content.product?.potentialPromotions!"></cx-promotions>
    </ng-container>
  }

  <ng-template [cxOutlet]="outlets.SUMMARY" [cxOutletContext]="{ product: content.product }">
    <p [innerHTML]="content.product?.summary" class="summary"></p>
  </ng-template>
</ng-container>
